import React, { useState } from "react";
import { Icon } from "../../components/simple/Icon";

export function Input({
  id = "",
  name = "",
  placeholder = "",
  type = "text",
  className: pClassName = "",
  value,
  disabled = false,
  maxLength = undefined,
  upperCase = false,
  error = false,
  label = "",
  enableEditingIfBadRegex,
  regex,
  max,
  onFocus,
  onClick,
  ...props
}) {
  const [{ touched }, setState] = useState({
    touched: false,
  });

  const setTouched = (touched) => {
    setState((prevState) => ({
      ...prevState,
      touched,
    }));
  };
  const onBlur = (e) => {
    setTouched(true);
    // setIsFilled(!!e.target.value.length)
    // if (checkUserAvatar && e.target.value.length > 5) {
    //   userAvatarHandler(e);
    // } else {
    //   if (resetDefaultUserAvatar) resetDefaultUserAvatar();
    // }
    if (props.onBlur) {
      props.onBlur(e);
    }
  };
  const handleOnFocus = (e) => {
    if (onFocus) onFocus(e);
  };

  const handleOnClick = () => {
    if (onClick) onClick();
  };

  const isSubSequence = (oldS, newS) => {
    if (!newS) return true;
    if (!oldS || oldS.length !== newS.length + 1) return false;
    for (let i = 0; i < oldS.length; i++) {
      if (newS.slice(0, i) + oldS[i] + newS.slice(i) === oldS) return true;
    }
    return false;
  };

  const onChange = (e) => {
    setTouched(true);
    if (
      maxLength &&
      type === "number" &&
      e.target.value.toString().length >= maxLength
    ) {
      return;
    }
    console.log("console", new RegExp(regex).test(e.target.value));
    if (!enableEditingIfBadRegex) {
      if (
        regex &&
        !(
          isSubSequence(value, e.target.value) ||
          new RegExp(regex).test(e.target.value)
        )
      )
        return;
    }

    //if supplied max props for threshold
    if (max && e.target.value > max) return;
    // cursor position
    let cursorStart = e.target.selectionStart;
    let cursorEnd = e.target.selectionEnd;
    // if text transformed
    let changed = false;
    // has supplied converter function in property
    // if (converter) {
    //   e.target.value = converter(e.target.value)
    //   changed = true
    // }
    // has supplied uppercase property
    // if (upperCase) {
    //   e.target.value = toUpperCase(e.target.value) // .toUpperCase();
    //   changed = true
    // }
    // props onChange
    if (props.onChange) props.onChange(e);
    if (changed) {
      e.target.setSelectionRange(cursorStart, cursorEnd);
    }
  };

  let val = value === null ? "" : value;

  let inputErrorClass = error ? " la-text-input__invalid " : "";

  return (
    <div className="form-group">
      {label && <label className="mb-8 label-01">{label}</label>}

      <input
        style={upperCase ? { textTransform: "uppercase" } : {}}
        id={`input-${id}`}
        className={
          pClassName +
          inputErrorClass +
          " la-text-input la-text-input la-text-input--lg"
        }
        name={name}
        value={val}
        onChange={onChange}
        type={type}
        disabled={disabled}
        onBlur={onBlur}
        maxLength={maxLength}
        placeholder={placeholder}
        onFocus={(e) => handleOnFocus(e)}
        autoComplete={"new-password"}
        onClick={handleOnClick}
      />
    </div>
  );
}
